import ModalLeavePromptContext from './ModalLeavePromptContext';
import useLeavePrompt from '../useLeavePrompt';

const useModalLeavePromptContext = () => useLeavePrompt(ModalLeavePromptContext);

export default useModalLeavePromptContext;
